import React from "react";

import {Box, Stack} from '@mui/material';


import HtmlHeader from "../ui/HtmlHeader";

import * as Page from "./PageContainer";
import { DomSub } from "tsui/Dom/DomSub";

// import AuthHeader from "./AuthHeader";
// import PageBanner from "./PageBanner";
import PageNav from "./PageNavBar";
import PageLogo from "./PageLogo";
import AuthHeader from "./AuthHeader";
import LangSelector from './LangSelector';

// import Env from "env";


export class PageHeaderState {

    domSub = new DomSub();

    release() {
        this.domSub.release();
    }
};


interface PageHeaderProps {
    current?: string;
    title?: string;
}


// export default function PageHeader(props: PageHeaderProps) {
//     if (Env.isMobile) {
//         return <Page.PageHeaderContainer>
//                 <HtmlHeader title={props.title ?? 'Bug Path Finder'} />
//                 <PageLogo/>
//                 <PageBanner/>
//                 <AuthHeader/>
//                 {/* <PageNav current={props.current ?? 'home'}/> */}
//             </Page.PageHeaderContainer>;
//     } else{
//             return <Page.PageHeaderContainer>
//                 <HtmlHeader title={props.title ?? 'Bug Path Finder'} />
//                 <PageLogo/>
//                 <PageBanner/>
//                 <AuthHeader/>
//                 <PageNav current={props.current ?? 'home'}/>
//             </Page.PageHeaderContainer>;
//     }
    
// }

export default function PageHeader(props: PageHeaderProps) {
    

    return (
        <Box sx={{
            position: 'absolute',
            width: '100%',
            minWidth: theme_.pageMinWidth,
            // min-width: 1800px;
            left: 0,
            right: 0,
            top: 0,
            height: theme_.pageHeaderHeight,
            zIndex: 1,
        }}>
            <HtmlHeader title={props.title ?? 'EvoCard - Smart Business Cards'} />

            <Stack
                direction='row'
                width='100%'
                justifyContent='center'
                alignItems='center'
            >
                <PageLogo />
                <Box sx={{width: '100%',}}/>
                {/* <PageNav current={props.current ?? 'home'} /> */}
                {/* <LangSelector type='button' /> */}
                <AuthHeader />
            </Stack>
        </Box>
    );
}

